import { useQuery } from '@tanstack/vue-query'

import { getOnboardingReviewPropertyOwnerList } from '../propertyOwnersEndpoints'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'
import type { GetPropertyOwnerListParams } from '../../types/propertyOwnerTypes'

// Onboarding-review queue size for the sidebar badge. The server endpoint
// hard-locks propertyOwnerStatus=PENDING_REVIEW + kycStatus=APPROVED, so any
// page/limit returns the queue total. limit:1 keeps the payload tiny.
const ONBOARDING_REVIEW_COUNT_PARAMS: GetPropertyOwnerListParams = {
  page: 1,
  limit: 1,
}

export function usePropertyOwnerOnboardingReviewCountQuery() {
  return useQuery({
    queryKey: ownersQueryKeys.onboardingReviewList(ONBOARDING_REVIEW_COUNT_PARAMS),
    queryFn: () => getOnboardingReviewPropertyOwnerList(ONBOARDING_REVIEW_COUNT_PARAMS),
    select: (res) => res.total,
  })
}
